import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import SearchRounded from "@mui/icons-material/SearchRounded";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreFilter from "../../../app/core/components/CoreFilter/CoreFilter";
import AutocompleteFilter from "../../../app/core/components/CoreFilter/components/AutocompleteFilter/AutocompleteFilter";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreTable from "../../../app/core/components/CoreTable/CoreTable";
import StudioFilter from "../../../app/core/components/UserFilter/StudioFilter";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import {
  useDeleteGroupStudioMutation,
  useGetGroupStudioQuery,
  useGetStudiosQuery,
  useSaveStudioMutation,
} from "../../api/admin/gestisciStudioApi";
import AddHomeWorkRoundedIcon from "@mui/icons-material/AddHomeWorkRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { IconButton, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog.jsx";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import CoreTabBar from "../../../app/core/components/CoreTabBar/CoreTabBar.jsx";
import CoreViewLists from "../../../app/core/components/CoreViewLists/CoreViewLists.jsx";
import {
  removeGlobalFilter,
  selectAllFilters,
  setMultipleGlobalFilters,
} from "../../../app/globalFiltersSlice";
import useSyncFilterWithGlobalFilters from "../../../utils/hookCustom.js";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi";
import { useGetUsersQuery } from "../../api/admin/gestisciUtentiApi";
import CreateGruop from "./GroupStudio/CreateGruop";
import SettingsGroup from "./GroupStudio/SettingsGroup.jsx";
import { ROLE } from "../../../utils/constants/profiles.js";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import DetailAdminGroup from "./GroupStudio/DetailAdminGroup.jsx";

const GestisciStudioPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const globalFilters = useSelector(selectAllFilters);
  const role = useSelector((state) => state.app.role);
  const appConfig = useSelector((state) => state.app.appConfig);
  const adminId = useSelector((state) => state.app.adminId);

  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [debouncedInputOperatorValue, setDebouncedInputOperatorValue] =
    useState("");
  const [rows, setRows] = useState([]);
  const [rowsGroup, setRowsGroup] = useState([]);
  const [studio, setStudio] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState(t("List"));
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [group, setGroup] = useState();
  const [settingsGroup, setSettingsGroup] = useState(false);
  const [addAdminGroup, setAddAdminGroup] = useState(false);
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [filter, setFilter] = useState({
    studioId: "",
    adminId: "",
  });

  const columns = {
    logoImageUrl: "Logo",
    name: t("Name"),
    email: "Email",
    groups: t("Group"),
    actions: t("Actions"),
  };
  const columnsGroup = {
    name: t("Name"),
    studios: t("Studios"),
    actions: t("Actions"),
  };

  const {
    data: usersData,
    isLoading: isUsersLoading,
    isFetching: isUsersFetching,
  } = useGetUsersQuery({
    page: page,
  });

  const { data, isFetching, isLoading, refetch } = useGetStudiosQuery({
    ...page,
    value: debouncedInputStudioValue,
    adminId: filter.adminId,
    studioId: filter.studioId,
  });

  const {
    data: dataGroup,
    isLoading: loadingGroup,
    refetch: refetchGroup,
  } = useGetGroupStudioQuery(adminId);

  const [saveStudio] = useSaveStudioMutation();
  const [deleteGroup] = useDeleteGroupStudioMutation();

  const {
    data: operatorsData,
    isFetching: isOperatorsFetching,
    isLoading: isOperatorsLoading,
  } = useGetCommercialistaQuery({
    page: page,
    value: debouncedInputOperatorValue,
  });

  useEffect(() => {
    const isValidation = data && data.Data && data.Data.items;

    const handlePrivacyStudio = (el) => {
      const id = toast.loading(`${t("Saving...")}`, {
        pauseOnFocusLoss: false,
        type: "info",
      });

      const bodyStudio = {
        ...el,
        isPrivate: el.isPrivate ? false : true,
      };

      saveStudio(bodyStudio)
        .unwrap()
        .then((res) => {
          if (res.Result !== 1) {
            toast.update(id, {
              render: res.Exception || `${t("SavingNotOk")}`,
              type: "error",
              autoClose: 1500,
              isLoading: false,
            });
            return;
          }

          toast.update(id, {
            render: `${t("StudioUpdated")}`,
            type: "success",
            autoClose: 1500,
            isLoading: false,
          });
        });
    };

    if (isValidation) {
      const studiosData = data.Data.items.map((el) => ({
        id: el.id,
        logoImageUrl: (
          <img
            src={
              el.logoImageUrl ? el.logoImageUrl : "/img/placeholder-logo.svg"
            }
            alt={el.logoImageUrl ? "logo" : "placeholder"}
            style={{ maxWidth: 125, maxHeight: 50 }}
          />
        ),
        name: el.name,
        email: el.email,
        groups:
          el?.groups.length > 0 ? (
            <CoreChip variant="outlined" label={el?.groups[0]?.group.name} />
          ) : null,
        isPrivate: el.isPrivate,
        actions: [
          {
            icon: <AssignmentIndRoundedIcon />,
            onClick: () => navigate(el.id),
            tooltip: t("StudioCard"),
          },
          {
            icon: el.isPrivate ? (
              <VisibilityOffOutlinedIcon className="text-blue-600" />
            ) : (
              <RemoveRedEyeOutlinedIcon />
            ),
            onClick: () => handlePrivacyStudio(el),
            tooltip: el.isPrivate ? t("Show") : t("Hide"),
          },
        ].map((action, index) => (
          <Tooltip title={action.tooltip} key={index}>
            <IconButton variant="outlined" onClick={action.onClick}>
              {action.icon}
            </IconButton>
          </Tooltip>
        )),
      }));
      setRows(studiosData);
    }
  }, [data, t, saveStudio, navigate]);

  useEffect(() => {
    if (dataGroup) {
      const groupData = dataGroup.Data.map((el) => ({
        id: el.id,
        name: el.name,
        studios:
          el?.studios.length > 0 ? (
            <CoreViewLists value={el?.studios} text={t("Studios")} />
          ) : (
            <p className="text-gray"> {t("NoBriefStudio")}</p>
          ),

        actions: [
          {
            icon: <EditRoundedIcon />,
            onClick: () => handleOpenEdit(el),
            tooltip: t("Edit"),
          },
          {
            icon: <AddHomeWorkRoundedIcon className="text-blue-400" />,
            onClick: () => handleOpenSettings(el),
            tooltip: t("MangeGroup"),
          },
          {
            icon: el.groupAdminId ? (
              <PersonRoundedIcon className="fill-green-600" />
            ) : (
              <PersonOutlineRoundedIcon className="fill-yellow-600" />
            ),
            onClick: () => handleOpenAddAdminGroup(el),
            tooltip: el.groupAdminId ? t("Edit") : t("Add"),
          },
          {
            icon: <DeleteIcon className={"fill-rose-600"} />,
            onClick: () => handleOpenDialod(el),
            tooltip: t("Delete"),
          },
        ].map((action, index) => (
          <Tooltip title={action.tooltip} key={index}>
            <IconButton variant="outlined" onClick={action.onClick}>
              {action.icon}
            </IconButton>
          </Tooltip>
        )),
      }));
      setRowsGroup(groupData);
    }
  }, [dataGroup, t]);

  const handleRefecth = () => {
    refetch();
    if (appConfig?.modules?.studio?.adminStudioGroup) {
      refetchGroup();
    }
  };

  const handleConfermDialog = () => {
    deleteGroup({ id: group.id }).then((res) => {
      if (res?.data?.Result === 1) {
        toast.success(`${t("DeletedGroup")}`);
        handleCloseDialod();
      } else {
        toast.error(`${t("NotDeletedGroup")}`);
      }
    });
  };

  const handleOpenDialod = (el) => {
    setConfirmDialog(true);
    setGroup(el);
  };

  const handleCloseDialod = () => {
    setConfirmDialog(false);
  };

  const handleClose = () => {
    setOpenModal(false);
    setGroup(null);
  };

  const handleOpen = () => {
    setOpenModal(true);
  };
  const handleOpenEdit = (group) => {
    setOpenModal(true);
    setGroup(group);
  };

  const handleOpenSettings = (el) => {
    setSettingsGroup(true);
    setGroup(el.id);
  };

  const handleCloseSettings = () => {
    setSettingsGroup(false);
    setGroup(null);
  };

  const handleOpenAddAdminGroup = (el) => {
    setAddAdminGroup(true);
    setGroup(el);
  };

  const handleCloseAddAdminGroup = () => {
    setAddAdminGroup(false);
    setGroup(null);
  };

  const TABS_STUDIO = [
    { label: t("List"), tab: t("List") },
    { label: t("Group"), tab: t("Group") },
  ];

  useSyncFilterWithGlobalFilters(setFilter);

  if (isLoading) {
    return <CoreSpinner />;
  }

  const transformFilters = (filtersArray) => {
    const filterObject = {
      studioId: "",
      adminId: "",
      userId: "",
    };

    filtersArray.forEach((filter) => {
      if (
        filter.key &&
        Object.prototype.hasOwnProperty.call(filterObject, filter.key)
      ) {
        filterObject[filter.key] = filter.value || "";
      }
    });

    return filterObject;
  };

  const handleFiltersChange = (newFilters) => {
    // Trasforma i filtri nel formato desiderato
    const transformedFilters = transformFilters(newFilters);

    // Ora puoi usare l'oggetto trasformato
    setFilter(transformedFilters);
  };

  const handleGlobalFiltersApply = (filters) => {
    // Separa i filtri con valori validi da quelli undefined/vuoti
    const validFilters = [];
    const filtersToRemove = [];

    filters.forEach((filter) => {
      if (filter.value !== undefined && filter.value !== "") {
        // Filtro con valore valido - mantienilo
        validFilters.push(filter);
      } else {
        // Filtro undefined o vuoto - rimuovilo
        filtersToRemove.push(filter.key);
      }
    });

    // Rimuovi i filtri undefined/vuoti dallo state
    filtersToRemove.forEach((filterKey) => {
      dispatch(removeGlobalFilter(filterKey));
    });

    // Imposta solo i filtri con valori validi
    if (validFilters.length > 0) {
      dispatch(setMultipleGlobalFilters(validFilters));
    }
  };

  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-between items-center">
          <h2 className="font-bold" style={{ width: "100px" }}>{`${t(
            "Studios"
          )}`}</h2>
          {appConfig?.modules?.studio?.adminStudioGroup && (
            <CoreTabBar tab={TABS_STUDIO} setSelectedTab={setSelectedTab} />
          )}
        </div>
        {selectedTab === t("List") && (
          <div className="flex flex-row -mt-8 justify-end space-x-2">
            <CoreFilter
              onFiltersChange={handleFiltersChange}
              onGlobalFiltersApply={handleGlobalFiltersApply}
              initialFilters={globalFilters}
            >
              {role === ROLE.ADMIN && (
                <AutocompleteFilter
                  label="Cerca Studio"
                  placeholder="Digita nome studio..."
                  options={data?.Data?.items}
                  filterKey="studioId"
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}
                  allowGlobal={true}
                />
              )}
              {role !== ROLE.OPERATOR && (
                <AutocompleteFilter
                  label="Cerca Operatore"
                  placeholder="Digita nome operatore..."
                  options={operatorsData?.Data?.items}
                  filterKey="adminId"
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) =>
                    `${option.name} ${option.surname}`
                  }
                  allowGlobal={true}
                />
              )}
              {/* 
              <AutocompleteFilter
                label="Cerca Cliente"
                placeholder="Digita nome cliente..."
                options={usersData?.Data?.items}
                filterKey="userId"
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => `${option.name} ${option.surname}`}
                allowGlobal={true}
              /> */}
            </CoreFilter>
          </div>
        )}
        <div className="flex flex-row justify-between">
          {selectedTab === t("List") && (
            <div className=" w-4/12">
              <StudioFilter
                selectedUser={studio}
                setSelectedUser={setStudio}
                usersList={data?.Data?.items}
                setDebouncedInputUserValue={setDebouncedInputStudioValue}
                isUsersLoading={isLoading}
                startAdornment={<SearchRounded />}
              />
            </div>
          )}
          <div className="w-8/12 flex items-center">
            <CoreButtonHoverIcon
              onClick={handleRefecth}
              className="text-blue-500 m-1 flex flex-row space-x-2 border"
              testo={t("Refresh")}
              icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
            />
            {selectedTab === t("List") && (
              <CoreButtonHoverIcon
                className="text-blue-700 m-1"
                icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
                testo={`${t("Studio")}`}
                onClick={() => navigate(t("createStudioRoute"))}
              />
            )}
            {appConfig?.modules?.studio?.adminStudioGroup &&
              selectedTab === t("Group") && (
                <CoreButtonHoverIcon
                  className="text-yellow-600 m-1"
                  icon={<AddBoxRoundedIcon className={`fill-yellow-600`} />}
                  testo={`${t("Group")}`}
                  onClick={handleOpen}
                />
              )}
          </div>
        </div>
      </div>

      <div className="py-5 ">
        {selectedTab === t("List") && (
          <CoreTable
            check={false}
            rows={rows}
            columns={columns}
            info={`${t("Studios")}`}
            setPage={setPage}
            page={page}
            totalPages={Math.ceil(data?.Data?.count / TABLE_ROWS_NUMBER) || 1}
            isLoading={isLoading || isFetching}
          />
        )}
        {selectedTab === t("Group") && (
          <CoreTable
            rows={rowsGroup}
            columns={columnsGroup}
            info={`${t("Group")}`}
            setPage={setPage}
            page={page}
            totalPages={
              Math.ceil(dataGroup?.Data?.length / TABLE_ROWS_NUMBER) || 1
            }
            isLoading={loadingGroup}
          />
        )}
      </div>

      <CoreModal
        width={"40%"}
        height={"40%"}
        state={openModal}
        onClose={handleClose}
        component={<CreateGruop onClose={handleClose} group={group} />}
      />
      <CoreModal
        width={"50%"}
        height={"50%"}
        state={settingsGroup}
        onClose={handleCloseSettings}
        component={<SettingsGroup groupId={group} onRefetch={refetchGroup} />}
      />
      <CoreModal
        width={"50%"}
        height={"50%"}
        state={addAdminGroup}
        onClose={handleCloseAddAdminGroup}
        component={
          <DetailAdminGroup group={group} onClose={handleCloseAddAdminGroup} />
        }
      />
      <CoreDialog
        open={confirmDialog}
        title={`${t("Delete")} ${t("group")}`}
        content={`${t("DeletingConfirm")} ${group?.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDialog}
        closeDialog={handleCloseDialod}
      />
    </>
  );
};

export default GestisciStudioPage;
